export default Object.freeze({
  ADMIN: 'ADMIN',
  VIEW_LOAD_AREA: 'View_LoadArea/Load/Load',
  VIEW_DUE_LEGAL_AREA_FILE_FILE_LIST: 'View_DueLegalArea/File/FileList',
  VIEW_MAP_DATA_AREA_MAP_DATA_MAIN_MAP: 'View_MapDataArea/MapData/MainMap',
  VAS_USER: 'VAS_User',
  PIX_TERRAFORM_CRUD: 'PIX_TERRAFORM_CRUD',
  VIEW_ADMIN_AREA_USERS_MNG_USERS: 'View_AdminArea/Users/MngUsers',
  VIEW_ADMIN_AREA_USERS_MNG_PROFILES: 'View_AdminArea/Users/MngProfiles',
  VIEW_ADMIN_AREA_USERS_MNG_ROLES: 'View_AdminArea/Users/MngRoles',
  VIEW_QTAG_INDEX: 'View_QTAG/Index',
  VIEW_ADMIN_AREA_AUTHORIZATION_MAPPING_INDEX: 'View_AdminArea/AuthorizationMapping/Index',
  VIEW_ADMIN_AREA_USERS_MNG_USER_PROFILE_ROLE: 'View_AdminArea/Users/MngUserProfileRole',
  RF_CHANGE_INSTANCE: 'RF_CHANGE_INSTANCE',
  DEV_MODE: 'DEV_MODE',
  VAS_CERTIFICATION_SECTION_MNG: 'VAS_CERTIFICATION_SECTION_MNG',
  INSTANCE_US: 'INSTANCE_US',
  DELETE_COMPS: 'R_CAN_DELETE_COMP',
  ADD_MANDATE: 'RTALOS_CREATE_JOB',
});
